// extracted by mini-css-extract-plugin
export default {"title":"PurchaseHistory_title__VNpQv"};